export default "__VITE_ASSET__ZFikJTUQ__"